<section class="section section-white" *ngIf="registers?.length > 0">
    <div class="container">
        <h5 *ngIf="this.isCbt" class="mb-4">Parceiros</h5>
        <ng-container *ngTemplateOutlet="this.partnetLayout"> </ng-container>
    </div>
</section>

<ng-template #carrouselLayout>
    <ngb-carousel
        style="display: flex; align-items: center; justify-content: center"
        [showNavigationIndicators]="false"
        [showNavigationArrows]="false"
        [interval]="3000"
    >
        <ng-template ngbSlide *ngFor="let group of parternsGroups">
            <div class="row justify-content-center align-items-center">
                <div
                    class="col-auto"
                    *ngFor="
                        let partner of registers
                            | slice
                                : group * parternsPerGroup
                                : (group === parternsGroups.length - 1
                                      ? registers.length
                                      : group * parternsPerGroup + parternsPerGroup);
                        let i = index
                    "
                >
                    <a [href]="partner.url_redirect" target="_blank" rel="nofollow noreferrer" class="partner">
                        <img [src]="partner.url_logo" [alt]="partner.title" />
                    </a>
                </div>
            </div>
        </ng-template>
    </ngb-carousel>
</ng-template>

<ng-template #straightPartners>
    <div class="row mb-2 justify-content-center align-items-center" *ngFor="let level of partnersByLevels">
        <div class="col-auto" *ngFor="let partner of level">
            <a [href]="partner.url_redirect" target="_blank" rel="nofollow noreferrer" class="partner">
                <img [src]="partner.url_logo" [alt]="partner.title" />
            </a>
        </div>
    </div>
</ng-template>
